//selectors for redux :
import { useSelector } from "react-redux";
import { getIdSpot, getLivraison, getRidingPeriod, getPanier, getAccess } from "../../../../../../store/selectors.js";


function InfosRecap3({ infos }) { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

    const accessList = useSelector(getAccess); //global state : id of the selected spo

    console.log(infos)
    console.log(accessList)

    function getInfos(access) {
        let leType = infos.length > 0 ? infos.find((info) => info.id_article === access.id_article).type : " ";
        return access.qte + " x " + leType;
    }
    return (
        <div className="infos-recap2">
            <div className="infos-recap2-ligne-1">
                <p className="infos-recap2-ligne-titre">Liste des accessoires :</p>
            </div>

            <div className="infos-recap2-ligne-2">
                {accessList.map((access, index) =>
                    <p key={index} className="infos-recap2-ligne-info">{getInfos(access)}</p>
                )}

            </div>



        </div>

    )
}




export default InfosRecap3